import { useState } from "react";
import React from "react";
import "../css/inputField.css";

const PasswordField = (props) => {
  const [focused, setFocused] = useState(false);
  const { label, errorMessage, onChange, id, ...inputProps } = props;
  const [showPasswordStatus, setShowPasswordStatus] = useState(false);

  const handleFocus = (e) => {
    //it targets the error in input field
    setFocused(true);
  };

  const password = (id) => {
    //gets the element by id
    var a = document.getElementById(id);
    //sets input type to password if true and vice-versa
    if (showPasswordStatus) {
      a.type = "password";
      setShowPasswordStatus(false);
    } else {
      a.type = "text";
      setShowPasswordStatus(true);
    }
  };
  
  return (
    <div className="formInput d-flex row-cols-2 w-75 m-3 justify-content-between">
      <h4>{label}</h4>
      <div className="position-relative">
        <input
          className="w-100 p-2"
          {...inputProps}
          onChange={onChange}
          onBlur={handleFocus}
          onFocus={() =>
            inputProps.name === "re_new_password" && setFocused(true)
          }
          focused={focused.toString()}
          id={inputProps.name}
        />
        {inputProps.name.includes("password") && (
          <p
            onClick={() => password(inputProps.name)}
            className="btn m-2 p-0 text-dark position-absolute end-0"
          >
            <i
              className={`fas fa-eye${!showPasswordStatus ? "-slash" : ""}`}
            ></i>
          </p>
        )}
        <span>{errorMessage}</span>
      </div>
    </div>
  );
};

export default PasswordField;
